import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import ProjectRequests from "../ProjectRequests/ProjectRequests";

const COPY = {
  title: "Project Requests",
  subtitle: "You Can See Accept & Reject Project Requests",
  searchPlaceholder: "Search Here",
};

const ProjectRequestsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getProjectRequests");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <ProjectRequests driverData={items} />
    </AdminPage>
  );
};

export default ProjectRequestsAdmin;
